
import React, { useState } from 'react'
import AddPaymentPopup from 'Popups/AddPaymentPopup/AddPaymentPopup';
import AddPatientPaymentPopup from 'Popups/AddPatientPaymentPopup/AddPatientPaymentPopup';
import RequestPaymentSearchGrid from './RequestPaymentSearchGrid';

const RequestPaymentSearch = ({ handlePaymentId, rows, handlePerRowsChange, handlePageChange, paramModel, handleSubmit, patientId }) => {
  const [paymentPopup, setPaymentPopup] = useState(false)
  const [state, setState] = useState({
    modalRow: null,
    showPaymentDetail: false,
  })

  return (
    <div className=''>
      {paymentPopup && <AddPaymentPopup onClose={() => setPaymentPopup(false)} />}
      {state.showPaymentDetail && <AddPatientPaymentPopup modalRow={state.modalRow} onClose={() => setState({ ...state, modalRow: null, showPaymentDetail: false })} />}

      <RequestPaymentSearchGrid
        allowPatientCol={!!patientId}
        handlePayment={handlePaymentId}
        rows={rows}
        handlePerRowsChange={handlePerRowsChange}
        handlePageChange={handlePageChange}
        handleSubmit={handleSubmit}
        paramModel={paramModel}
      />


    </div>
  )
}

export default RequestPaymentSearch
RequestPaymentSearch.displayName = 'RequestPaymentSearch';